export const COACHING_ADDON_STORAGE_KEY = 'equ_coaching_addon_selected';

/** Save the coaching addon selection state to sessionStorage */
export const persistCoachingAddonToSession = (selected: boolean): void => {
  try {
    if (typeof sessionStorage === 'undefined') {
      return;
    }
    if (selected) {
      sessionStorage.setItem(COACHING_ADDON_STORAGE_KEY, 'true');
    } else {
      sessionStorage.removeItem(COACHING_ADDON_STORAGE_KEY);
    }
  } catch {
    // sessionStorage may be unavailable in private browsing on some browsers
  }
};

/** Read whether the coaching addon was selected from sessionStorage */
export const getCoachingAddonFromSession = (): boolean => {
  try {
    if (typeof sessionStorage === 'undefined') {
      return false;
    }
    return sessionStorage.getItem(COACHING_ADDON_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

/** Clear the coaching addon selection state from sessionStorage */
export const clearCoachingAddonFromSession = (): void => {
  try {
    if (typeof sessionStorage === 'undefined') {
      return;
    }
    sessionStorage.removeItem(COACHING_ADDON_STORAGE_KEY);
  } catch {
    // no-op
  }
};
